
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-alert color="error" v-if="error">{{error}}</v-alert>
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Kategorien</v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <p>Verwalten Sie ihre angelegten Kategorien.</p>
                    <a @click="addCategory()">
                      <v-btn class="primary" style="position: absolute; right: 40px">
                        Neues Kategorie
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </a>
                  </v-row>
                  <v-row>
                    <v-col cols="4" v-for="item of categories" :key="item.id">
                      <v-card >
                        <div class="d-flex flex-no-wrap justify-space-between">
                          <div>
                            <v-card-title class="headline" v-text="item.name"></v-card-title>
                            <v-card-subtitle>{{item.description.substring(0, 60) + '...'}}</v-card-subtitle>
                          </div>

                          <v-avatar class="ma-3" size="125" tile>
                            <v-img :src="'http://acs.accelery.de/api/assets/'+ item.assetId"></v-img>
                          </v-avatar>
                        </div>

                        <v-card-actions>
                          <v-btn text @click="editCategory(item.id)">
                            <v-icon>mdi-pencil</v-icon>Bearbeiten
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";
import productService from "@/services/ProductService";
export default {
  name: "categories",
  components: {
    Header: Header
  },
  data: () => ({
    loading: true,
    categories: null,
    error: null
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      try {
        this.categories = (
          await productService.getAllProductCategories(this.$route.params.id)
        ).data;
        this.loading = false;
      } catch (err) {
        this.error = err.message;
        this.loading = false;
      }
    },

    editCategory(id) {
      router.push({
        name: "editCategory",
        params: { id: this.$route.params.id, catId: id }
      });
    },

    addCategory(id) {
      router.push({
        name: "addCategory",
        params: { id: this.$route.params.id }
      });
    }
  }
};
</script>

<style scoped>
  div {
    word-wrap:break-word;
  }
</style>
